export default "__VITE_ASSET__92e4bd26__"